import React, { useEffect, useState } from "react";
import axios from "axios";
import PageHero from "../components/PageHero";
import { Phone, GraduationCap, Stethoscope } from "lucide-react";
import { HOSPITAL } from "../data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Doctors() {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/doctors`)
      .then((r) => setDoctors(r.data))
      .catch(() => setDoctors([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="doctors-page">
      <PageHero
        eyebrow="Our team"
        title={<>Meet the doctors who'll <span className="italic text-brand-maroon">care for your family.</span></>}
        subtitle="A team of senior consultants and skilled specialists, all at one hospital — accessible, experienced, and patient-focused."
        image="https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=1400&q=85"
      />

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-20">
        {loading ? (
          <p className="text-brand-ink/60">Loading doctors…</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {doctors.map((d) => (
              <article
                key={d.id}
                data-testid={`doctor-card-${d.id}`}
                className="group rounded-3xl overflow-hidden bg-white border border-brand-beige hover:shadow-lg transition"
              >
                <div className="aspect-[4/5] overflow-hidden bg-brand-beige">
                  <img
                    src={d.image}
                    alt={d.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-brand-maroon">
                    {d.department}
                  </div>
                  <h3 className="font-serif-display text-2xl text-brand-ink mt-2">{d.name}</h3>
                  <div className="flex items-center gap-2 text-sm text-brand-ink/70 mt-2">
                    <Stethoscope size={14} />
                    {d.specialty}
                  </div>
                  <div className="flex items-center gap-2 text-xs text-brand-ink/55 mt-1">
                    <GraduationCap size={14} />
                    {d.qualification}
                  </div>
                  <p className="text-sm text-brand-ink/65 mt-4 leading-relaxed">{d.bio}</p>
                  <div className="mt-5 flex items-center justify-between">
                    <span className="text-xs uppercase tracking-[0.18em] text-brand-ink/50">
                      {d.experience_years}+ yrs
                    </span>
                    <a
                      href={`tel:${HOSPITAL.phoneDial}`}
                      data-testid={`doctor-call-${d.id}`}
                      className="inline-flex items-center gap-2 text-sm font-semibold text-brand-maroon hover:text-brand-maroonDark"
                    >
                      <Phone size={14} /> Book
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
